import type { RouteRecordRaw } from 'vue-router';

// 小红花模块路由暂时下线
const routes: RouteRecordRaw[] = [];

/* 原路由配置（暂时下线）
const routes = [
  {
    path: '/xiaohonghua',
    name: 'xiaohonghua-index',
    component: () => import('@/views/xiao-hong-hua/IndexView.vue'),
    meta: {
      title: '送你一朵小红花',
      keepAlive: true,
    },
  },
  {
    path: '/xiaohonghua/rule',
    name: 'xiaohonghua-rule',
    component: () => import('@/views/xiao-hong-hua/RuleView.vue'),
    meta: {
      title: '送你一朵小红花',
    },
  },
  {
    path: '/xiaohonghua/rule',
    name: 'xiaohonghua-rule',
    component: () => import('@/views/xiao-hong-hua/RuleView.vue'),
    meta: {
      title: '活动规则',
    },
  },
  {
    path: '/xiaohonghua/myflowerlist',
    name: 'xiaohonghua-myflowerlist',
    component: () => import('@/views/xiao-hong-hua/MyFlowerList.vue'),
    meta: {
      title: '我的小红花',
    },
  },
  {
    path: '/xiaohonghua/mycertificate',
    name: 'xiaohonghua-mycertificate',
    component: () => import('@/views/xiao-hong-hua/MyCertificate.vue'),
    meta: {
      title: '我的证书',
    },
  },
  {
    path: '/xiaohonghua/game',
    name: 'xiaohonghua-game',
    component: () => import('@/views/xiao-hong-hua/question/QuestionIndex.vue'),
    meta: {
      title: '科普公益答题',
    },
  },
  {
    path: '/xiaohonghua/invite',
    name: 'xiaohonghua-invite',
    component: () => import('@/views/xiao-hong-hua/InviteView.vue'),
    meta: {
      title: '邀请好友',
    },
  },
];
*/

export default routes;
